import { routing } from "../../routing.js";
export function createClient(api) {
  async function list() {
    const url = routing.templatesUrl;
    const {
      templates
    } = await api.get(url);
    return templates;
  }
  async function get(templateId) {
    const url = routing.templatesUrl;
    const {
      template
    } = await api.get(`${url}/${templateId}`);
    return template;
  }
  async function create(payload) {
    const url = routing.templatesUrl;
    const {
      template
    } = await api.post(url, {
      payload
    });
    return template;
  }
  async function update(templateId, payload) {
    const url = routing.templatesUrl;
    const {
      template
    } = await api.patch(`${url}/${templateId}`, {
      payload
    });
    return template;
  }
  async function doDelete(templateId) {
    const url = routing.templatesUrl;
    return api.delete(`${url}/${templateId}`);
  }
  return {
    list,
    get,
    create,
    update,
    delete: doDelete
  };
}